import { render, staticRenderFns } from "./AdminManageSpecialistFee.vue?vue&type=template&id=77c11401"
import script from "./AdminManageSpecialistFee.vue?vue&type=script&lang=js"
export * from "./AdminManageSpecialistFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports